<template>
	<div class="layout-home">
		<app-header :link="landingLink"/>
		<banner 
			@open-modal="openRegisterBanner"
			@open-modal-btn="openRegister"
			:number-money="numberMoney"
			:code="countryCode"
			:link="landingLink"
			:lat="lat"
			:lon="lon"
		/>
		<section-mobile @open-modal-btn="openRegister"/>
		<section-about />
		<section-how-it-work-slider 
			:link="landingLink"
			@open-modal-btn="openRegister"/>
		<section-slider />
		<section-features @open-modal-btn="openRegister"/>
		<section-our-plans :code="countryCode"/>
		<section-banner 
			:link="landingLink" 
			:number-money="numberMoney"
			:discount-money="discountMoney"/>
		<section-faq 
			:landing-link="landingLink"
			@open-register="openRegister" 
			:code="countryCode"/>
		<section-brand></section-brand>
		<section-addresses></section-addresses>
		<app-footer></app-footer>
		<v-dialog
			v-model="dialog"
			persistent
			max-width="400"
			@keydown.esc="closeModal"
		>
			<v-card>
				<div class="container-iframe" v-show="!loading">
					<div class="container-close">
						<v-btn
							depressed
							flat
							icon
							@click="closeModal"
						>
							 <img src="/static/images/sections/close.svg" alt="cerrar" height="20">
						</v-btn>
					</div>
					<iframe 
						:src="linkPageIFrame" 
						style="border:0px #ffffff none;" 
						name="myiFrame" 
						scrolling="no"
						frameborder="1" 
						marginheight="0px" 
						marginwidth="0px" 
						height="600" 
						width="100%"
						allow="geolocation"
						allowfullscreen>
					</iframe>
				</div>
				<div v-show="loading" class="container-progrees">
					<v-progress-circular
					:size="70"
					:width="7"
					indeterminate
					color="teal darken-1">
				</v-progress-circular>
				</div>
			</v-card>
		</v-dialog>
	</div>
</template>
<script>
import appFooter from '@/components/home/app-footer';
import appHeader from '@/components/home/app-header';
import banner from '@/components/home/banner';
import sectionAbout from '@/components/home/section-about';
import sectionAddresses from '@/components/home/section-addresses';
import sectionApp from '@/components/home/section-app';
import sectionBanner from '@/components/home/section-banner';
import sectionBenefits from '@/components/home/section-benefits';
import sectionBrand from '@/components/home/section-brand';
import sectionFaq from '@/components/home/section-faq';
import sectionFeatures from '@/components/home/section-features';
import sectionMobile from '@/components/home/section-mobile';
import sectionHowItWork from '@/components/home/section-how-it-work';
import sectionHowToUse from '@/components/home/section-how-to-use';
import sectionSlider from '@/components/home/section-slider';
import sectionHowItWorkSlider from '@/components/home/section-how-it-work-slider';
import sectionOurPlans from '@/components/home/section-our-plans';

function created() {
	this.loadData();
}

function openModal(action) {
	this.linkPageIFrame = action.linkPage;
	this.dialog = true;
	setTimeout(() => { this.loading = false; }, 3000);
}

function closeModal() {
	this.dialog = false;
	this.loading = true;
	this.linkPageIFrame = '';
}

function numberMoney() {
	return this.countryCode === 'EC' ? '$150' : 'S/500';
}

function discountMoney() {
	return this.countryCode === 'EC' ? 'S/300' : 'S/300';
}

function openRegister() {
	this.linkPageIFrame = `https://casamarket.la/activa-tu-app?plan=true&code=${this.countryCode}&lat=${this.lat}&lon=${this.lon}#formulario`;
	this.dialog = true;
	setTimeout(() => { this.loading = false; }, 3000);
}

function openRegisterBanner(flag) {
	let url = `https://casamarket.la/activa-tu-app?code=${this.countryCode}&lat=${this.lat}&lon=${this.lon}#formulario`;
	if (flag) {
		url = `https://casamarket.la/activa-tu-app?plan=true&code=${this.countryCode}&lat=${this.lat}&lon=${this.lon}#formulario`;
	}
	this.linkPageIFrame = url;
	this.dialog = true;
	setTimeout(() => { this.loading = false; }, 3000);
}

async function loadData() {
	try {
		const response = await this.$httpGeoLocation.get();
		const { countryCode } = response.data;
		this.countryCode = response.data.countryCode;
		this.lat = response.data.lat;
		this.lon = response.data.lon;
		const codeByCountry = {
			PE: `${process.env.PER_REGISTER}`,
			EC: `${process.env.ECU_REGISTER}`,
		};
		this.landingLink = codeByCountry[countryCode];
	} catch (error) {
		this.showGenericError();
	}
}

function data() {
	return {
		landingLink: '',
		dialog: false,
		linkPageIFrame: '',
		loading: true,
		countryCode: '',
		lat: null,
		lon: null,
	};
}

export default {
	name: 'page-home',
	components: {
		appFooter,
		appHeader,
		banner,
		sectionAbout,
		sectionAddresses,
		sectionApp,
		sectionBanner,
		sectionBenefits,
		sectionBrand,
		sectionFaq,
		sectionFeatures,
		sectionHowItWork,
		sectionHowToUse,
		sectionSlider,
		sectionHowItWorkSlider,
		sectionOurPlans,
		sectionMobile,
	},
	computed: {
		numberMoney,
		discountMoney,
	},
	methods: {
		openModal,
		closeModal,
		openRegister,
		loadData,
		openRegisterBanner,
	},
	created,
	data,
};
</script>
<style lang="scss">
	.container-iframe {
		position: relative;

		.btn__content {
			background: color(white) !important;
			box-shadow: -2px 4px 9px 0px rgba(0,0,0,0.14);
		}
	}

	.container-close {
		position: absolute;
		right: 10px;
		top: 10px;
	}

	.container-progrees {
		align-items: center;
		display: flex;
		justify-content: center;
		height: 600px;
	}
</style>


// WEBPACK FOOTER //
// src/pages/page-home.vue